import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "../../configureStore";

const selectState = (state: RootState) => state.application;

const makeSelectLoading = createDraftSafeSelector(selectState, (state) => state.loading);
const makeSelectLoadingData = createDraftSafeSelector(selectState, (state) => state.loadingData);

const makeSelectApplication = createDraftSafeSelector(selectState, (state) => state.application);
export const makeSelectCargoPlanning = createDraftSafeSelector(selectState, (state) => state.cargoPlanning);
const makeSelectSalesIndicative = createDraftSafeSelector(selectState, (state) => state.salesIndicative);
const makeSelectLoadingSalesIndicative = createDraftSafeSelector(selectState, (state) => state.loadingSalesIndicative);
const makeSelectSalesIndicativeError = createDraftSafeSelector(selectState, (state) => state.salesIndicativeError);
const makeSelectLoadingSuggestions = createDraftSafeSelector(selectState, (state) => state.loadingSuggestions);
const makeSelectApplicationSuggestions = createDraftSafeSelector(selectState, (state) => state.applicationSuggestions);
const makeSelectRecommendations = createDraftSafeSelector(selectState, (state) => state.recommendations);
const makeSelectLoadingRecommendations = createDraftSafeSelector(selectState, (state) => state.loadingRecommendations);
const makeSelectRecommendationsError = createDraftSafeSelector(selectState, (state) => state.recommendationsError);
export const makeSelectQuotationPreview = createDraftSafeSelector(selectState, (state) => state.quotationPreview);
export const makeSelectRecommendationRouteSelection = createDraftSafeSelector(selectState, (state) => state.recommendationRouteSelection);
export const makeSelectRecommendationRouteReset = createDraftSafeSelector(selectState, (state) => state.recommendationRouteReset);
export const makeSelectRecommendationWishMutation = createDraftSafeSelector(selectState, (state) => state.recommendationWishMutation);
export const makeSelectRecommendationQuotationCopy = createDraftSafeSelector(selectState, (state) => state.recommendationQuotationCopy);
export const makeSelectRecommendationBusy = createDraftSafeSelector(
  selectState,
  (state) =>
    state.loadingData ||
    state.recommendationRouteReset?.status === "pending" ||
    state.recommendationRouteSelection?.status === "pending" ||
    state.recommendationWishMutation?.status === "pending" ||
    state.recommendationQuotationCopy?.status === "pending",
);

const makeSelectServices = createDraftSafeSelector(selectState, (state) => state.services);

const makeSelectActiveCalculationKey = createDraftSafeSelector(selectState, (state) => state.activeCalculationKey);

const makeSelectAiFillerModalOpen = createDraftSafeSelector(selectState, (state) => state.aiFillerModalOpen);
const makeSelectAiFillerModalLoading = createDraftSafeSelector(selectState, (state) => state.aiFillerModalLoading);
const makeSelectAiFillerMessages = createDraftSafeSelector(selectState, (state) => state.aiFillerMessages);
const makeSelectAiFillerLogId = createDraftSafeSelector(selectState, (state) => state.aiFillerLogId);
const makeSelectAiFillerLogUpdatedAt = createDraftSafeSelector(selectState, (state) => state.aiFillerLogUpdatedAt);
const makeSelectAiFillerError = createDraftSafeSelector(selectState, (state) => state.aiFillerError);
const makeSelectBorderCrossings = createDraftSafeSelector(selectState, (state) => state.borderCrossings);

export {
  selectState,
  makeSelectLoading,
  makeSelectLoadingData,
  makeSelectApplication,
  makeSelectSalesIndicative,
  makeSelectLoadingSalesIndicative,
  makeSelectSalesIndicativeError,
  makeSelectLoadingSuggestions,
  makeSelectApplicationSuggestions,
  makeSelectRecommendations,
  makeSelectLoadingRecommendations,
  makeSelectRecommendationsError,
  makeSelectServices,
  makeSelectActiveCalculationKey,
  makeSelectAiFillerModalOpen,
  makeSelectAiFillerModalLoading,
  makeSelectAiFillerMessages,
  makeSelectAiFillerLogId,
  makeSelectAiFillerLogUpdatedAt,
  makeSelectAiFillerError,
  makeSelectBorderCrossings,
};
